module.exports = __webpack_public_path__ + "img/online.50e620b6.svg";